import { render } from "./CouponItem.vue?vue&type=template&id=18d029f1&scoped=true"
import script from "./CouponItem.vue?vue&type=script&lang=js"
export * from "./CouponItem.vue?vue&type=script&lang=js"

import "./CouponItem.vue?vue&type=style&index=0&id=18d029f1&lang=scss&scoped=true"

import exportComponent from "D:\\QYYY\\mall_pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18d029f1"]])

export default __exports__